import { LoginRequest, LoginResponse } from '@aaa-ncnu-ie/mypolicy-api-login';
import { useMutation } from '@tanstack/react-query';

import getAndSetLocalAuthCookies from '../../utils/getAndSetLocalAuthCookies';
import axios from '../axios';

const isLocal =
  window.location.hostname === 'localhost' ||
  window.location.hostname ===
    'localhost.mypolicy.digital.n01.csaa-insurance.aaa.com';

export const handleDirectAccessLogin = async (sessionToken: string) => {
  if (isLocal) {
    /**
     * This is a local dev only (read localhost) workaround for Direct Access logins.
     * Because OKTA will not accept localhost as a redirect URI, we have to run the redirects in an http call
     * and strip the access_token/id_token from the html response and manually set the cookies
     */
    const stripDomainLoginUrl = `${
      import.meta.env.VITE_OKTA_LOGIN_URL
    }&sessionToken=${sessionToken}`.split('csaainsurance.oktapreview.com')[1];
    await getAndSetLocalAuthCookies(stripDomainLoginUrl);
  } else {
    location.href = `${
      import.meta.env.VITE_OKTA_LOGIN_URL
    }&sessionToken=${sessionToken}`;
  }
};

export const login = async (requestBody: LoginRequest) => {
  const { data } = await axios.post<LoginResponse>(
    `${import.meta.env.VITE_LOGIN_API_URL}/v1/login`,
    requestBody
  );

  return data;
};

export const useLoginMutation = () =>
  useMutation({
    mutationFn: (requestBody: LoginRequest) => login(requestBody),
  });
